var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_POST_VIEW_TYPE } from "../actions/setPostViewType";
var initialState = {
    type: "wide",
};
export function setPostViewType(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_POST_VIEW_TYPE:
            return __assign(__assign({}, state), { type: action.payload });
        default:
            return state;
    }
}
//# sourceMappingURL=setPostViewType.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_POST_VIEW_TYPE } from "../actions/setPostViewType";
var initialState = {
    type: "wide",
};
export function setPostViewType(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_POST_VIEW_TYPE:
            return __assign(__assign({}, state), { type: action.payload });
        default:
            return state;
    }
}
//# sourceMappingURL=setPostViewType.js.map